<template>
  <div
    v-if="contact.contactsWithCommonEmailAddressCount || contact.contactsWithCommonPhoneNumberCount"
    class="rounded-md bg-yellow-50 p-4"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-yellow-800">
          {{ $t('contact.duplicate_records_found_title') }}
        </h3>
        <div class="mt-2 text-sm text-yellow-700">
          <p v-if="contact.contactsWithCommonEmailAddressCount">
            {{
              $t('contact.records_with_common_email_address_found_description', {
                count: contact.contactsWithCommonEmailAddressCount,
              })
            }}
          </p>
          <p v-if="contact.contactsWithCommonPhoneNumberCount">
            {{
              $t('contact.records_with_common_phone_number_found_description', {
                count: contact.contactsWithCommonPhoneNumberCount,
              })
            }}
          </p>
        </div>
        <div class="mt-2">
          <BaseButton
            tag="router-link"
            small
            warning
            outline
            :to="{
              name: 'accounts.accountId.contactMerge',
              query: {
                contact_id: contactId,
              },
            }"
          >
            {{ $t('contact.manage_duplicates') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
  },
};
</script>
